
import { Button } from "@/components/ui/button";
import { Mail } from "lucide-react";

interface ContactSalesButtonProps {
  className?: string;
  onClick: () => void;
}

const ContactSalesButton = ({ className, onClick }: ContactSalesButtonProps) => {
  return (
    <Button 
      className={`w-full md:w-auto flex items-center gap-2 ${className || ""}`}
      onClick={onClick}
    >
      <Mail size={16} />
      Contact Sales
    </Button>
  );
};

export default ContactSalesButton;
